import type { CityDto } from "../types/city";
import { env } from "../config/env";
import { apiRequest } from "./client";

const CITIES_PAGE_SIZE = "999999";

let citiesRequest: Promise<CityDto[]> | null = null;

function normalizeCitiesResponse(body: unknown): CityDto[] {
  const items = Array.isArray(body)
    ? body
    : body && typeof body === "object" && "data" in body
      ? (body as { data: unknown }).data
      : [];

  if (!Array.isArray(items)) return [];

  return items.flatMap((item) => {
    if (!item || typeof item !== "object") return [];
    const city = item as Record<string, unknown>;
    const id = Number(city.id);
    const name = typeof city.name === "string" ? city.name.trim() : "";
    if (!Number.isFinite(id) || !name) return [];

    return [
      {
        ...city,
        id,
        name,
      } as CityDto,
    ];
  });
}

export function fetchCities(): Promise<CityDto[]> {
  if (citiesRequest) return citiesRequest;

  const params = new URLSearchParams({
    "pagination[pageSize]": CITIES_PAGE_SIZE,
  });
  citiesRequest = apiRequest<unknown>(`/api/v1/geo/cities?${params}`, {
    baseUrl: env.identityApiBaseUrl,
    auth: false,
    credentials: "omit",
  })
    .then(normalizeCitiesResponse)
    .catch((error) => {
      citiesRequest = null;
      throw error;
    });

  return citiesRequest;
}

export function clearCitiesCache(): void {
  citiesRequest = null;
}

/** Поиск по единожды загруженному каталогу городов. */
export async function searchCities(nameLike: string): Promise<CityDto[]> {
  const query = nameLike.trim();
  if (query.length < 2) return [];

  const normalizedQuery = query.toLocaleLowerCase("ru-RU");
  const cities = await fetchCities();
  return cities.filter((city) =>
    city.name.toLocaleLowerCase("ru-RU").includes(normalizedQuery),
  );
}
